<template>
	<div class="mopage">		
		
		
		<!-- <div class="row">
			<div class="pl-4 ml-auto">
				<button class="btn btn-simple btn-primary" @click="AddMObject()">Добавить объект</button>
			</div>
		</div> -->


		<!-- 
		<MObjectNest />
		-->
		<mo_allbuildings />
		<!-- <pre>
			{{ ApiData }}
		</pre> -->


	</div>
</template>
<script>


// import MObjectNest from 'src/our_modules/MarketingModule/MObjectNest.vue';
import mo_allbuildings from "src/our_modules/MarketingModule/mo_allbuildings.vue";

export default {
	name: 'mo-page',
	components: {
		// MObjectNest,
		mo_allbuildings,
	},
	data() {
		return {
			ApiData:{},			
			
		};
	},
	watch: {
		

	},
	computed: {

	},
	methods: {
		getApiData(){
			this.$GVO.ApiCall('MyObj.GET',{flt:{list:true}})
				.then((objApi) => {
					// console.log(objApi);
					if(objApi.success){
						this.ApiData = objApi;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
		},
		AddMObject(){
			this.$router.push({path: '/data/module/mo/object/add'});
			// console.log('Хочешь объкты -- пиши свое апи');
		},
		// setDefaultUrl(masDefaultParams){
		// 	let queryParams = new URLSearchParams('');
		// 	for (let i = 0; i < masDefaultParams.length; i++) {
		// 		queryParams.append(masDefaultParams[i][0],masDefaultParams[i][1]);
		// 	}
		// 	history.replaceState(null, null, "?"+queryParams.toString());
		// },
		
	},
	mounted() {
		
	},
	created(){
		// let objGetParams = this.$GVO.GetAllGet();
		/*
		this.podbor=objGetParams.hasOwnProperty('task_id'); // Если пришёл код задачи, то это подбор и не показывает кнопки переключения рынков
		if(typeof objGetParams.dSearchType != 'undefined'){
			if(['flats','flatmap'].indexOf(objGetParams.dSearchType) !==-1){
				this.market.activeIndex = 1;
			}else{
				this.market.activeIndex = 0;
			}
		}
		*/
	}
};
</script>
<style scoped>

</style>

